<template>
  <div>
    <div class="breadcrumbs">
      <div class="container">
        <a href="/">首页</a> <span class="sep">/</span> <span>个人中心</span>
      </div>
    </div>
    <div class="mi-user-portal page-main">
      <div class="container ">
        <div class="row">
          <div class="span4">
            <left-nav></left-nav>
          </div>
          <div class="span16">
            <div class="mi-uc-box uc-main-box">
              <div class="uc-content-box portal-content-box">
                <div class="box-bd">
                  <el-form ref="form" :model="form" label-width="90px">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="账号：">
                          <el-input
                            v-model="form.account"
                            :class="isReadOnly()"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12"> </el-col>
                      <el-col :span="12">
                        <el-form-item label="姓名：">
                          <el-input
                            v-model="form.name"
                            :class="isReadOnly()"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12"> </el-col>
                      <el-col :span="12">
                        <el-form-item label="电话：">
                          <el-input
                            v-model="form.mobile"
                            :class="isReadOnly()"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12"> </el-col>
                      <el-col :span="12">
                        <el-form-item label="邮箱：">
                          <el-input
                            v-model="form.email"
                            :class="isReadOnly()"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12"> </el-col>
                      <el-col :span="12">
                        <el-form-item label="密码：">
                          <el-input
                            v-model="form.password"
                            :class="isReadOnly()"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12"> </el-col>
                      <el-col :span="12">
                        <el-form-item>
                          <div>
                            <el-button type="primary" @click="onSave"
                              >保存
                            </el-button>
                            <el-button @click="goBack">取消 </el-button>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LeftNav from "../Layout/LeftNav.vue";
import { api } from "@/assets/js/util.js";
export default {
  name: "Profile",
  components: {
    "left-nav": LeftNav,
  },
  data() {
    return {
      form: {},
      is_read_only: false,
    };
  },
  mounted() {},
  methods: {
    onEdit() {
      this.is_read_only = false;
    },
    goBack() {
      this.$router.back();
    },
    isReadOnly() {
      if (this.is_read_only) {
        return "is_read_only";
      }
    },
    onSave() {
      let that = this;
      api.post("account/add", that.form).then(function(res) {
        if (res.code) {
          that.form = res.data;
          that.$message({
            type: "success",
            message: res.msg,
            duration: 1200,
            onClose: function() {
              that.$router.push("/account");
            },
          });
        } else {
          that.$message({
            type: "error",
            message: res.msg,
            duration: 1200,
          });
        }
      });
    },
  },
};
</script>
<style>
.is_read_only {
  pointer-events: none;
}
.is_read_only input {
  border: 0 !important;
}
</style>
